import { render, staticRenderFns } from "./Gashapon.vue?vue&type=template&id=0c787967&scoped=true&"
import script from "./Gashapon.vue?vue&type=script&lang=js&"
export * from "./Gashapon.vue?vue&type=script&lang=js&"
import style0 from "./Gashapon.vue?vue&type=style&index=0&id=0c787967&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c787967",
  null
  
)

export default component.exports